import React, { useState, useEffect } from "react";
import "../styles/register.css";

export default function Register({ addToast }) {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVerify, setPasswordVerify] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptEmails, setAcceptEmails] = useState(true);
  const [acceptAll, setAcceptAll] = useState(false);


  //TITLE BEÁLLITÁS
  useEffect(() => {
    document.title = "Regisztráció - FociFanatik"
  }, []);

  // "Összes elfogadása" logika
  useEffect(() => {
    if (acceptTerms && acceptEmails) {
      setAcceptAll(true);
    } else {
      setAcceptAll(false);
    }
  }, [acceptTerms, acceptEmails]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!acceptTerms) {
      addToast("El kell fogadnod az ÁSZF-et és az Adatkezelési tájékoztatót a regisztrációhoz!", "warning");
      return;
    }
    if (!username || !email || !password || !passwordVerify) {
      addToast("Kérlek, tölts ki minden mezőt!", "warning");
      return;
    }
    if (password !== passwordVerify) {
      addToast("A két jelszó nem egyezik!", "warning");
      return;
    }
    if (password.length < 6) {
      addToast("A jelszó legyen legalább 6 karakter!", "warning");
      return;
    }

    fetch("https://focifanatik.hu/api/register.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ username, email, password, passwordVerify, acceptTerms, acceptEmails }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          addToast(data.success, "success");

          
          //EMAIL KÜLDÉSE A FELHASZNÁLÓNAK
          fetch("https://focifanatik.hu/api/sendMail.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              type: "register",
              to: email,
              data: {
                username: username
              }
            })
          })

          //EMAIL KÜLDÉS A TULAJDONOSNAK REGISZTRÁCIÓNÁL
          fetch("https://focifanatik.hu/api/sendMail.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              type: "newRegisterNotification",
              to: "owner@gmail.com",
              data: {
                username: username
              }
            })
          })

          setTimeout(() => {
            window.location.href = "/bejelentkezes";
          }, 1500);

        } else {
          addToast(data.error, "warning");
        }
      })
      .catch(() => addToast("Hálózati hiba!", "warning"));
  };

  return (
    <section className="register-page">
      <div className="register-card">

        {/* BAL OLDAL – ÉRTÉK */}
        <div className="register-info">
          <h2>Csatlakozz a TippBázishoz</h2>

          <p className="register-lead">
            Regisztrálj 30 másodperc alatt, és használd a <strong>statisztikákat</strong>,
            <strong> stratégiákat</strong> és <strong>jegyzeteket</strong> egy helyen.
          </p>

          <ul className="register-benefits">
            <li><i className="bi bi-bar-chart"></i> Meccs statisztikák</li>
            <li><i className="bi bi-pie-chart-fill"></i> Saját stratégiák</li>
            <li><i className="bi bi-card-text"></i> Saját jegyzetek</li>
            <li><i className="bi bi-graph-up"></i> Hosszú távú fejlődés</li>
            <li><i className="bi bi-chat-dots-fill"></i> Aktiv közösség</li>
            <li><i className="bi bi-wallet"></i> Teljesen ingyenes</li>
          </ul>

        </div>

        {/* MOBIL INFO – CSAK MOBILON */}
        <div className="register-info-mobile">
          <div className="rim-header">
            <span className="rim-badge">100% ingyenes</span>
            <h4>TippBázis előnyei</h4>
          </div>

          <ul>
            <li>📊 Statisztikák</li>
            <li>🧠 Stratégiák</li>
            <li>📝 Jegyzetek</li>
            <li>📈 Fejlődés</li>
            <li>💬 Közösség</li>
            <li>🔒 Biztonságos</li>
          </ul>
        </div>



        {/* JOBB OLDAL – FORM */}
        <form onSubmit={handleSubmit} className="register-form">
          <h3>Regisztráció</h3>

          <div className="form-group">
            <label>Felhasználónév</label>
            <input
              type="text"
              placeholder="Felhasználónév"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </div>

          <div className="form-group">
            <label>Jelszó</label>
            <input
              type="password"
              placeholder="Jelszó"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>

          <div className="form-group">
            <label>Jelszó megerősítés</label>
            <input
              type="password"
              placeholder="Jelszó újra"
              value={passwordVerify}
              onChange={(e) => setPasswordVerify(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <div className="terms-group">

            {/* ELFOGADJA AZ ÖSSZES CHECKBOXOT */}
            <label className="terms-label">
              <input
                type="checkbox"
                checked={acceptAll}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setAcceptAll(checked);
                  setAcceptTerms(checked);
                  setAcceptEmails(checked);
                }}
              />
              <span>
                Elfogadom az összes feltételt.
              </span>
            </label>

            {/* ELFOGADJA A FELTÉTELEKET ASZF, ADATKEZELES */}
            <label className="terms-label">
              <input
                type="checkbox"
                checked={acceptTerms}
                onChange={(e) => setAcceptTerms(e.target.checked)}
              />
              <span>
                Elfogadom az{" "}
                <a href="/aszf" target="_blank">Általános Szerződési Feltételeket</a>{" "}
                és az{" "}
                <a href="/adatkezeles" target="_blank">Adatkezelési tájékoztatót</a>.
              </span>
            </label>

            {/* ELFOGADJA A HIRLEVELEKET */}
            <label className="terms-label">
              <input
                type="checkbox"
                checked={acceptEmails}
                onChange={(e) => setAcceptEmails(e.target.checked)}
              />
              <span>
                Szeretnék e-mailben értesítéseket, tippeket és újdonságokat kapni a FociFanatiktól.
              </span>
            </label>
          </div>

          <button type="submit" className="register-btn">
            Fiók létrehozása
          </button>

          <p className="register-footer">
            Már van fiókod?{" "}
            <a href="/bejelentkezes">Bejelentkezés</a>
          </p>
        </form>

      </div>
    </section>
  );
}
